if (!customElements.get('tpt-marquee-text')) {
	customElements.define(
		'tpt-marquee-text',
		class TptMarqueeText extends HTMLElement {
			connectedCallback() {
				this.track = this.querySelector('[data-marquee-track]');
				this.group = this.querySelector('[data-marquee-group]');

				if (!this.track || !this.group) return;

				this.groupTemplate = this.group.cloneNode(true);
				this._onResize = () => this.scheduleSetup();

				this.resizeObserver = new ResizeObserver(this._onResize);
				this.resizeObserver.observe(this);

				this.querySelectorAll('img').forEach((img) => {
					if (!img.complete) {
						img.addEventListener('load', this._onResize, { once: true });
					}
				});

				this.scheduleSetup();
			}

			disconnectedCallback() {
				this.resizeObserver?.disconnect();
				clearTimeout(this.setupTimer);
			}

			scheduleSetup() {
				clearTimeout(this.setupTimer);
				this.setupTimer = setTimeout(() => this.setup(), 50);
			}

			setup() {
				if (!this.track || !this.groupTemplate) return;

				const containerWidth = this.offsetWidth;

				if (!containerWidth) return;

				this.track.classList.remove('is-ready');
				this.track.replaceChildren();

				const firstGroup = this.groupTemplate.cloneNode(true);
				this.track.appendChild(firstGroup);

				const groupWidth = firstGroup.offsetWidth;

				if (!groupWidth) return;

				// Fill until one half is at least as wide as the viewport
				let safety = 0;

				while (this.track.scrollWidth < containerWidth && safety < 50) {
					this.track.appendChild(this.groupTemplate.cloneNode(true));
					safety += 1;
				}

				// Duplicate the filled half so -50% loops seamlessly
				const halfClones = Array.from(this.track.children).map((child) => {
					const clone = child.cloneNode(true);
					clone.setAttribute('aria-hidden', 'true');
					return clone;
				});

				for (const clone of halfClones) {
					this.track.appendChild(clone);
				}

				this.track.classList.add('is-ready');
			}
		}
	);
}
